export default function getInitials(name: string, fallback = '?'): string {
  if (!name || typeof name !== 'string') return fallback;
  return name
    .split(' ')
    .filter(Boolean) // filter out the empty strings
    .slice(0, 2) // We take only two words of the name for the initial
    .map((s) => s[0].toUpperCase()) // Convert the first digit of those two strings to uppercase
    .join('');
}
